const scripts = [
  {
    labelInfo: 'Tokio Marine',
    script: `
      <script>
        (function () {
          var s = document.createElement('script');
          s.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
          s.setAttribute('data-tenant-uuid', '883e1a51-522b-4ed1-9381-e45933a18361');
          s.setAttribute('data-domain-uuid', '3bbb4d0a-25c9-4e20-ab86-f477e4aaa3a3');
          s.setAttribute('data-backend-url', 'https://app.securiti.ai');
          s.setAttribute('data-skip-css', 'false');
          s.defer = true;
          var parent_node = document.head || document.body;
          parent_node.appendChild(s);
        })()
      </script>
    `
  },
  {
    labelInfo: 'Pernambucanas',
    script: `
      <script>
        (function () {
          var s = document.createElement('script');
          s.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
          s.setAttribute('data-tenant-uuid', '883e1a51-522b-4ed1-9381-e45933a18361');
          s.setAttribute('data-domain-uuid', '8fd6df9b-d327-487c-ad04-6f2544a19e00');
          s.setAttribute('data-backend-url', 'https://app.securiti.ai');
          s.setAttribute('data-skip-css', 'false');
          s.defer = true;
          var parent_node = document.head || document.body;
          parent_node.appendChild(s);
        })()
      </script>
    `
  },
  {
    labelInfo: 'Ticket',
    script: `
      <script>
      (function () {
        var s = document.createElement('script');
        s.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
        s.setAttribute('data-tenant-uuid', '883e1a51-522b-4ed1-9381-e45933a18361');
        s.setAttribute('data-domain-uuid', '1d356521-acd5-4fb5-8f37-b43348042ad2');
        s.setAttribute('data-backend-url', 'https://app.securiti.ai');
        s.setAttribute('data-skip-css', 'false');
        s.defer = true;
        var parent_node = document.head || document.body;
        parent_node.appendChild(s);
      })()
      </script>
    `
  }
]


const documentTitle = (title: string, labelInfo: any) => {
  document.title = `${title ? `${title} | ` : ''}${labelInfo.name}`;
  const favicon = document.getElementById('favicon') as HTMLLinkElement;
  favicon.href = `/${labelInfo.slug}/favicon.ico`;

  const script = scripts.find(script => script.labelInfo === labelInfo.name);
  if (script) {
    const template = document.createElement('template');
    template.innerHTML = script.script.trim();
    const scriptTag = template.content.firstChild;
    if (scriptTag) {
      document.head.appendChild(scriptTag);
    }
  }
};

export default documentTitle;
